import config from '@/config'
//千分位
export function formatToLocal(value) {
  if (value == null || value === '') return '0'
  const locale = 'en-US' //config.locale || 'en-US'
  return Number(value).toLocaleString(locale, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  })
}
export const formatAmountShort = num => {
  const amount = Number(num)
  if (!Number.isFinite(amount)) return '0'

  const absAmount = Math.abs(amount)
  const sign = amount < 0 ? '-' : ''

  const national = config.defaultCountry

  if (national === 'in') {
    if (absAmount >= 1e7) return `${sign}${formatToLocal(absAmount / 1e7)}Cr`
    if (absAmount >= 1e5) return `${sign}${formatToLocal(absAmount / 1e5)}L`
    if (absAmount >= 1e3) return `${sign}${formatToLocal(absAmount / 1e3)}K`
    return `${sign}${formatToLocal(absAmount)}`
  } else {
    if (absAmount >= 1e9) return `${sign}${formatToLocal(absAmount / 1e9)}B`
    if (absAmount >= 1e6) return `${sign}${formatToLocal(absAmount / 1e6)}M`
    if (absAmount >= 1e3) return `${sign}${formatToLocal(absAmount / 1e3)}K`
    return `${sign}${formatToLocal(absAmount)}`
  }
}

// 金额单位：前后端通信为「分」，前端展示为「元」

/**
 * 分 → 元（千分位字符串，用于表格/文案展示，勿用于 el-input-number）
 */
export function centsToYuan(cents, isshort = false) {
  if (cents == null || cents === '') return 0
  const n = Number(cents)
  return isshort ? formatAmountShort(n / 100) : formatToLocal(n / 100)
}

/**
 * 分 → 元（纯数字，用于表单输入、el-input-number 绑定）
 */
export function centsToYuanNumber(cents) {
  if (cents == null || cents === '') return 0
  const n = Number(cents)
  return Number.isNaN(n) ? 0 : n / 100
}

/**
 * 元 → 分（用户输入传给后端）
 * @param {number|string|null|undefined} yuan - 用户输入的金额（元）
 * @returns {number} 分，整数
 */
export function yuanToCents(yuan) {
  if (yuan == null || yuan === '') return 0
  const n = Number(yuan)
  return Number.isNaN(n) ? 0 : Math.round(n * 100)
}
